export default class Calendar extends HTMLElement {
    whenLoaded = Promise.all([
        customElements.whenDefined('calendar-range'),
        customElements.whenDefined('calendar-date')
    ]);

    constructor(m) {
        super(m);

        // Binding
        this.onCalendarChange = this.onCalendarChange.bind(this);
        this.onInputChange = this.onInputChange.bind(this);

        // UI
        this.$input = this.querySelector('[data-input]');

        // Data
        this.hasSetTomorrow = this.getAttribute('data-set-tomorrow') !== null;
    }

    // =============================================================================
    // Lifecycle methods
    // =============================================================================
    connectedCallback() {
        this.whenLoaded.then(() => {
            this.$calendar = this.querySelector('[data-calendar]');
            this.reset();
            this.bindEvents();
        });
    }

    disconnectedCallback() {
        this.unbindEvents();
    }

    // =============================================================================
    // Events
    // =============================================================================
    bindEvents() {
        this.$calendar?.addEventListener('change', this.onCalendarChange);
        this.$input && this.$input.addEventListener('input', this.onInputChange);
    }

    unbindEvents() {
        this.$calendar?.removeEventListener('change', this.onCalendarChange);
        this.$input && this.$input.removeEventListener('input', this.onInputChange);
    }

    // =============================================================================
    // Callbacks
    // =============================================================================
    onCalendarChange(e) {
        this.$input && (this.$input.value = e.target.value);

        // Dispatch custom event
        window.dispatchEvent(
            new CustomEvent('calendarChange', {
                detail: {
                    value: e.target.value,
                    el: this.$calendar
                }
            })
        );
    }

    onInputChange(e) {
        this.$calendar.value = e.target.value;
    }

    // =============================================================================
    // Methods
    // =============================================================================
    reset() {
        const today = new Date().toISOString().split('T')[0];
        const tomorrow = new Date(new Date().getTime() + 24 * 60 * 60 * 1000)
            .toISOString()
            .split('T')[0];
        this.$calendar.min = this.getAttribute('data-min') || today;
        this.$calendar.max = this.getAttribute('data-max') || null;
        if (this.getAttribute('data-value')) {
            this.$calendar.value = this.getAttribute('data-value');
        } else {
            this.$calendar.value = this.hasSetTomorrow ? `${today}/${tomorrow}` : today;
        }
        /* this.$calendar.tentative = this.$calendar.value; */
        this.$input && (this.$input.value = this.$calendar.value);
    }
}
